import { Component } from '@angular/core';

@Component({
    selector: 'youtube-icon',
    template: '<img src="/assets/svgs/socials/youtube.png" height=27 width=27>',
    styleUrls: ['../svg.component.scss']
})
export class YoutubeIcon {

}